<template>
  <div class="area_lang">
    <atoms-drop-down
      v-model="selectedLang"
      :options="langList"
      item-key="code"
      prepend-icon="globe"
      append-icon="chevron_down"
      color-pack="gray"
      @update:model-value="onSelectLanguage"
    />
  </div>
</template>
<script setup lang="ts">
const { localeProperties, locales, locale } = useI18n()
const switchLocalePath = useSwitchLocalePath()
const route = useRoute()

const selectedLang = ref(localeProperties.value.name)
const langList = computed(() => locales.value.map((locale) => locale.name))

function onSelectLanguage(newLangName: string) {
  const newLocale = locales.value.find((locale) => locale.name === newLangName)
  if (!newLocale) return

  const newCode = newLocale.code
  if (newCode !== locale.value) {
    const newPath = switchLocalePath(newCode)

    if (newPath && newPath !== '') {
      window.location.href = newPath
    } else {
      // fallback: 현재 경로에서 기존 locale을 newCode로 교체 - 에러 페이지에서 언어 변경 시 대응
      const currentPath = route.fullPath
      const fallbackPath = currentPath.replace(
        `/${locale.value}`,
        `/${newCode}`
      )
      window.location.href = fallbackPath
    }
  }
}
</script>
<style lang="scss" scoped>
.area_lang {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 18px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  .dropdown.gray {
    min-width: 140px;

    :deep(.txt_selected) {
      height: 44px;
      background-color: rgba(255, 255, 255, 0.1);
      border: none;
      color: $white;
      padding: 10px 16px;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
        border: none;
      }

      span {
        min-width: 71px;
      }

      .icon_prepend {
        width: 13px;
        height: 13px;
        margin-right: 4px;
      }

      .icon_append {
        width: 16px;
        height: 16px;
      }
    }

    :deep(.list_dropdown) {
      background-color: $white;
      padding: 16px 0;
      border-radius: 8px;

      li {
        display: flex;
        align-items: center;
        padding: 0 16px;
        height: 33px;

        &:hover {
          background-color: $bg-l-purple;
          font-weight: 700;
          color: $blue1;
        }
      }
    }

    // 드랍다운 오픈 방향 = 상단
    :deep(.ps) {
      margin: 0;
      top: 0;
      transform: translateY(calc(-100% - 8px));
    }
  }
}
</style>
